import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, ArrowDownCircle, ArrowUpCircle, PieChart, Sparkles, Users } from 'lucide-react';
import type { FinancialSubTab } from './useFinancialFilters';

interface SubTabNavProps {
  active: FinancialSubTab;
  onChange: (tab: FinancialSubTab) => void;
}

export const SubTabNav: React.FC<SubTabNavProps> = ({ active, onChange }) => {
  const { t } = useTranslation();
  const tabs: { key: FinancialSubTab; label: string; Icon: React.ComponentType<{ className?: string }> }[] = [
    { key: 'overview',    label: t('financialReport.tabOverview',    { defaultValue: 'Overview' }),     Icon: LayoutDashboard },
    { key: 'deposits',    label: t('financialReport.tabDeposits',    { defaultValue: 'Deposits' }),     Icon: ArrowDownCircle },
    { key: 'withdrawals', label: t('financialReport.tabWithdrawals', { defaultValue: 'Withdrawals' }),  Icon: ArrowUpCircle },
    { key: 'mix',         label: t('financialReport.tabMix',         { defaultValue: 'Payment Mix' }),  Icon: PieChart },
    { key: 'ftd',         label: t('financialReport.tabFtd',         { defaultValue: 'FTD' }),          Icon: Sparkles },
    { key: 'players',     label: t('financialReport.tabPlayers',     { defaultValue: 'Players' }),      Icon: Users },
  ];

  return (
    <div className="flex flex-wrap gap-2 border-b border-slate-200 dark:border-slate-700">
      {tabs.map(({ key, label, Icon }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            className={`flex items-center gap-2 rounded-t-lg px-4 py-2 text-sm font-medium transition-colors -mb-px ${
              isActive
                ? 'border-x border-t border-slate-200 border-b-white bg-white text-accent dark:border-slate-700 dark:border-b-slate-900 dark:bg-slate-900 dark:text-accent'
                : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-white'
            }`}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        );
      })}
    </div>
  );
};
